import { render } from "./g-button.vue?vue&type=template&id=38d93e89&scoped=true"
import script from "./g-button.vue?vue&type=script&lang=js"
export * from "./g-button.vue?vue&type=script&lang=js"

import "./g-button.vue?vue&type=style&index=0&id=38d93e89&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d93e89"]])

export default __exports__